<template>
	<img :src="src" :alt="alt" @load="setImageLoaded()" :style="`opacity:${isLoaded ? 1 : 0}`" />
</template>

<script>
import { setTimeout } from 'timers';
export default {
	props: ['src', 'alt'],
	data: () => ({
		isLoaded: false
	}),
	methods: {
		setImageLoaded() {
			this.isLoaded = true;
			setTimeout(() => {
				this.$emit('load');
			}, 500);
		}
	}
};
</script>

<style scoped>
img {
	transition: opacity 0.2s ease-in-out;
}
</style>
